import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-form" }
const _hoisted_2 = { class: "block card-header" }
const _hoisted_3 = { class: "h3" }
const _hoisted_4 = { class: "flex gutter-x-s1 align-items-center caption pt-s2" }
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "steps steps-column" }
const _hoisted_7 = { class: "card-footer" }
const _hoisted_8 = { class: "mr-s1" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Spinner from '@/components/Spinner.vue';
import Icon from '@/components/icon/Icon.vue';
import Step from '@/components/stepper/Step.vue';
import { STEP_STATUS, StepInfo } from '@/components/stepper/stepper.types';
import { useSwap } from '@/store/modules/swap/useSwap';
import { format } from '@/utils/format';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { useSwapSteps } from '@/store/modules/swap/useSwapSteps';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwapSteps',
  emits: ["onClose"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'onClose'): void;
}), expose: any, slots: any, attrs: any }) {

const { t, te } = useI18n();
const { swapForm, updateWSCState, $reset: resetSwapForm, resetWSCState } = useSwap();
const { swapSteps, $reset: resetSteps } = useSwapSteps();



const isError = computed(() =>
  swapSteps.steps.some((step: StepInfo) => step.status === STEP_STATUS.ERROR),
);
const isSuccessful = computed(() =>
  swapSteps.steps.every((step: StepInfo) => step.status === STEP_STATUS.SUCCESS),
);
const isButtonDisabled = computed(
  () =>
    !(
      isError.value ||
      swapSteps.steps.every((step: StepInfo) => step.status === STEP_STATUS.SUCCESS)
    ),
);
const infoMessage = computed(() => {
  const activeStep = swapSteps.steps.findIndex(step => step.status === STEP_STATUS.ACTIVE);
  const msgType = swapSteps.steps[activeStep]?.type ?? 'default';
  return te(`swap.steps.infoMessage.${msgType}`)
    ? t(`swap.steps.infoMessage.${msgType}`)
    : t('wrappedContract.steps.infoMessage.default');
});
const onBackToForm = () => {
  if (isSuccessful.value) {
    resetSwapForm(true);
  }
  resetWSCState();
  updateWSCState();
  resetSteps();
  emits('onClose');
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('swap.steps.header', {
              input: _unref(swapForm).input.token?.symbol,
              output: _unref(swapForm).output.token?.symbol,
            })), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(swapForm).input.amount ?? 0)), 1),
          _createVNode(TokenIcon, {
            "icon-src": _unref(swapForm).input.token?.tokenIconUrl,
            size: "16"
          }, null, 8, ["icon-src"]),
          _createVNode(Icon, {
            name: "exchange",
            size: "16"
          }),
          _createElementVNode("div", null, _toDisplayString(_unref(format)(_unref(swapForm).output.amount ?? 0)), 1),
          _createVNode(TokenIcon, {
            "icon-src": _unref(swapForm).output.token?.tokenIconUrl,
            size: "16"
          }, null, 8, ["icon-src"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swapSteps).steps, (step, index) => {
            return (_openBlock(), _createBlock(Step, {
              key: index,
              number: index + 1,
              name: step.name!,
              status: step.status
            }, null, 8, ["number", "name", "status"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          class: "w-full button-card-form",
          disabled: _unref(isButtonDisabled),
          onClick: onBackToForm
        }, {
          default: _withCtx(() => [
            (_unref(isButtonDisabled))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(Spinner, {
                    size: "24",
                    class: "mr-s2"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)('swap.swap')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(t)('swap.steps.backToForm')), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex mt-s3 p-s3", _unref(isError) ? 'panel-message-error' : 'panel-message-info'])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Icon, {
          name: "error",
          size: "16"
        })
      ]),
      _createElementVNode("div", null, _toDisplayString(_unref(isError) ? _unref(t)('wrappedContract.steps.infoMessage.error') : _unref(infoMessage)), 1)
    ], 2)
  ]))
}
}

})